import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const NotificationsRedirect = () => {
    const { user, loading } = useAuth();

    // Wait for auth initialization
    if (loading) {
        return <div>Loading...</div>;
    }

    // If not authenticated, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Redirect based on user role
    if (user.user_type === 'admin') {
        return <Navigate to="/admin/notifications" replace />;
    } else {
        return <Navigate to="/user/notifications" replace />;
    }
};

export default NotificationsRedirect;
